import gql from "@/api/gql.js"
import { query, mutation } from "./queries.js"
import resolveApiErrors from "@/api/resolveApiErrors"

export default {
	async insurers(variables) {
		const res = await gql({
			query: query.insurers,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithoutList",
			res,
			resKey: "insurers"
		})
	},

	async products(variables) {
		const res = await gql({
			query: query.products,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "products_2"
		})
	},

	async internals(variables) {
		const res = await gql({
			query: query.internals,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "internals"
		})
	},

	async organizations(variables) {
		const res = await gql({
			query: query.organizations,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "organizations"
		})
	},

	async users(variables) {
		const res = await gql({
			query: query.users,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "internals"
		})
	},

	async insuranceTypes() {
		const res = await gql({
			query: query.insuranceTypes
		})

		return resolveApiErrors({
			resolutionType: "queryWithoutList",
			res,
			resKey: "productTypes"
		})
	},

	async permissionGroups(variables) {
		const res = await gql({
			query: query.permissionGroups,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithoutList",
			res,
			resKey: "permissionGroups"
		})
	},

	async addPolicyNote(variables) {
		const res = await gql({
			query: mutation.addPolicyNote,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "addPolicyNote"
		})
	},

	async updatePolicyNote(variables) {
		const res = await gql({
			query: mutation.updatePolicyNote,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "updatePolicyNote"
		})
	},

	async deletePolicyNote(variables) {
		const res = await gql({
			query: mutation.deletePolicyNote,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "removePolicyNote"
		})
	},

	async addEntityNote(variables) {
		const res = await gql({
			query: mutation.addEntityNote,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "addEntityNote"
		})
	},

	async updateEntityNote(variables) {
		const res = await gql({
			query: mutation.updateEntityNote,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "updateEntityNote"
		})
	},

	async deleteEntityNote(variables) {
		const res = await gql({
			query: mutation.deleteEntityNote,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "removeEntityNote"
		})
	},

	async addNoteToCase(variables) {
		const res = await gql({
			query: mutation.addNoteToCase,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "addNoteToCase"
		})
	},

	async removeNoteFromCase(variables) {
		const res = await gql({
			query: mutation.removeNoteFromCase,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "removeNoteFromCase"
		})
	},

	async updateNoteOfCase(variables) {
		const res = await gql({
			query: mutation.updateNoteOfCase,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "updateNoteOfCase"
		})
	},

	async deletePolicyAttachment(variables) {
		const res = await gql({
			query: mutation.deletePolicyAttachment,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "removePolicyAttachment"
		})
	},

	async deleteEntityAttachment(variables) {
		const res = await gql({
			query: mutation.deleteEntityAttachment,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "removeEntityAttachment"
		})
	},

	async deleteFile(variables) {
		const res = await gql({
			query: mutation.deleteFile,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "deleteFile"
		})
	},

	async individuals(variables) {
		const res = await gql({
			query: query.individuals,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "individuals"
		})
	},

	async companies(variables) {
		const res = await gql({
			query: query.companies,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "companies"
		})
	},

	async addContact(variables) {
		const res = await gql({
			query: mutation.addContact,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "addContact"
		})
	},

	async addIdentity(variables) {
		const res = await gql({
			query: mutation.addIdentity,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "addIdentity"
		})
	},

	async addAddress(variables) {
		const res = await gql({
			query: mutation.addAddress,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "addAddress"
		})
	},

	async addFact(variables) {
		const res = await gql({
			query: mutation.addFact,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "addFact"
		})
	},

	async addLink(variables) {
		const res = await gql({
			query: mutation.addLink,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "addLink"
		})
	},

	async deleteContact(variables) {
		const res = await gql({
			query: mutation.deleteContact,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "deleteContact"
		})
	},

	async deleteIdentity(variables) {
		const res = await gql({
			query: mutation.deleteIdentity,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "deleteIdentity"
		})
	},

	async deleteAddress(variables) {
		const res = await gql({
			query: mutation.deleteAddress,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "deleteAddress"
		})
	},

	async deleteFact(variables) {
		const res = await gql({
			query: mutation.deleteFact,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "deleteFact"
		})
	},

	async removeLink(variables) {
		const res = await gql({
			query: mutation.removeLink,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "removeLink"
		})
	},

	async updateContact(variables) {
		const res = await gql({
			query: mutation.updateContact,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "updateContact"
		})
	},

	async updateIdentity(variables) {
		const res = await gql({
			query: mutation.updateIdentity,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "updateIdentity"
		})
	},

	async updateAddress(variables) {
		const res = await gql({
			query: mutation.updateAddress,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "updateAddress"
		})
	},

	async updateFact(variables) {
		const res = await gql({
			query: mutation.updateFact,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "updateFact"
		})
	},

	async updateIndividual(variables) {
		const res = await gql({
			query: mutation.updateIndividual,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "updateIndividual"
		})
	},

	async updateCompany(variables) {
		const res = await gql({
			query: mutation.updateCompany,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "updateCompany"
		})
	},

	async updateObject(variables) {
		const res = await gql({
			query: mutation.updateObject,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "updateObject"
		})
	},

	async updateInternal(variables) {
		const res = await gql({
			query: mutation.updateInternal,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "updateInternal"
		})
	},

	async addClaimNote(variables) {
		const res = await gql({
			query: mutation.addClaimNote,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "addClaimNote"
		})
	},

	async updateClaimNote(variables) {
		const res = await gql({
			query: mutation.updateClaimNote,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "updateClaimNote"
		})
	},

	async removeClaimNote(variables) {
		const res = await gql({
			query: mutation.removeClaimNote,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "removeClaimNote"
		})
	},

	async updateOrganization(variables) {
		const res = await gql({
			query: mutation.updateOrganization,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "updateOrganization"
		})
	}
}
